import { render, staticRenderFns } from "./ComponentsTabs.vue?vue&type=template&id=51ff760c"
import script from "./ComponentsTabs.vue?vue&type=script&lang=js"
export * from "./ComponentsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports